import styled from 'styled-components';
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ManagerFooter from './manager/manager.footer';
import ManagerHeader from './manager/manager.header';
import UserHeader from './user/user.header';
import UserFooter from './user/user.footer';
import JoinHeader from './join/join.header';
import CommonHeader from './common.header';
import { useRecoilValue } from 'recoil';
import { authState } from '../../atoms/authState';

interface ILayoutProps {
  children: ReactNode;
  menuTitle: string;
  showBackArrow?: boolean;
  whiteBgColor: boolean;
  isFooter: boolean;
}

interface LocationState {
  pathname: string;
}

const CommonLayout = ({
  children,
  menuTitle,
  showBackArrow,
  whiteBgColor,
  isFooter,
}: ILayoutProps) => {
  const { pathname } = useLocation() as LocationState;
  const auth = useRecoilValue(authState); // Recoil에서 상태 가져오기

  const isUser = auth.userType === 'driver';
  const isManager = auth.userType === 'company';
  const isJoin = auth.userType === '';

  const renderHeader = () => {
    if (pathname === '/login' || pathname === '/') {
      // /login 또는 / 경로일 때 헤더 숨기기
      return null;
    }

    if (isManager) {
      return (
        <ManagerHeader menuTitle={menuTitle} showBackArrow={showBackArrow} />
      );
    } else if (isUser) {
      return <UserHeader menuTitle={menuTitle} showBackArrow={showBackArrow} />;
    } else if (isJoin) {
      return <JoinHeader menuTitle={menuTitle} />;
    } else if (pathname === '/login' || pathname === '/') {
      return null;
    } else {
      return <CommonHeader menuTitle={menuTitle} />;
    }
  };

  const renderFooter = () => {
    if (isUser && isFooter) {
      return <UserFooter />;
    }
    if (isManager && isFooter) {
      return <ManagerFooter />;
    }
    return null;
  };

  return (
    <Container $isWhiteBackground={whiteBgColor}>
      <Inner>
        {renderHeader()}
        <Body>{children}</Body>
        {renderFooter()}
      </Inner>
    </Container>
  );
};

export default CommonLayout;

// Styles
const Container = styled.div<{ $isWhiteBackground: boolean }>`
  height: 100vh;
  background-color: ${(props) =>
    props.$isWhiteBackground
      ? props.theme.textWhiteColor
      : props.theme.homeBgColor};
`;

const Inner = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

const Body = styled.main`
  align-self: stretch;
  position: relative;
  overflow: hidden;
`;
